<app-header [progress]="2" [title]="locale.currentTranslation.accidentDescriptionHeader" data-testid="detail-accident-description-header"></app-header>
<div class="base-content-container" data-testid="detail-accident-description-container">
  <div class="headline3" data-testid="detail-accident-description-title">{{ locale.currentTranslation.detailAccidentDescription1 }}
  </div>
  <div style="display: flex; flex-direction: column; gap: 24px;" data-testid="description-form">
    <div>
      <div>
        <app-text-area [(value)]="accidentDetailDescription"
          [placeholder]="locale.currentTranslation.detailAccidentDescriptionPlaceholder"
          [required]="true"
          [showError]="showError"
          data-testid="textarea-accident-description"
          [attr.aria-label]="locale.currentTranslation.detailAccidentDescriptionPlaceholder">
        </app-text-area>
      </div>
    </div>
  </div>
  @if (showError) {
    <div class="caption1 error-text" data-testid="validation-error" role="alert">
      {{ locale.currentTranslation.errorMessageUserInputNotFilled }}
    </div>
  }
</div>
<div class="main-button-spacing">
  <button class="main-button" (click)="nextClicked()" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
</div>
<app-footer data-testid="detail-accident-description-footer"></app-footer>
